/**
 * CentroThemeDataSource.ts
 *
 * Module for Theme options for Centro
 */

import { ConfigUpdatedListener } from "@ms/centro-hvc-loader";
import * as Configuration from "../../Configuration/Configuration";
import { ICentroThemeOptions } from "./CentroInterfaces";

// This is the object which is used to open/close/update data to Floodgate Centro
export class CentroThemeDataSource {
	/* Centro Theme options */
	public centroThemeOptions: ICentroThemeOptions;

	/* This is the list of listeners need to be invoked when the initOptions change */
	private listeners: ConfigUpdatedListener<ICentroThemeOptions>[] = [];

	private static instance: CentroThemeDataSource;

	public static get() {
		if (!this.instance) {
			this.instance = new CentroThemeDataSource();
		}
		return this.instance;
	}

	constructor() {
		this.centroThemeOptions = {
			baseTheme: Configuration.get().getDynamicUxConfig().theme,
			customTheme: Configuration.get().getDynamicUxConfig().customTheme,
			surveyUxCSSParams: Configuration.get().getFloodgateInitOptions().surveyCSSParams,
			footerButtonsAlignment: Configuration.get().getDynamicUxConfig().footerButtonsAlignment
		};
	}

	/*
	Register and Unregister is part of the boilerplate code to enable dynamic data passing
	*/
	public register(
		listener?: ConfigUpdatedListener<ICentroThemeOptions>
	): Readonly<Partial<ICentroThemeOptions>> {
		if (listener) {
			this.listeners.push(listener);
		}
		return this.centroThemeOptions;
	}

	public unregister(listener: ConfigUpdatedListener<ICentroThemeOptions>): void {
		const index = this.listeners.indexOf(listener);
		if (index > -1) {
			this.listeners.splice(index, 1);
		}
	}

	// Update function if the init options change in runtime
	public updateThemeState(updatedstate: Partial<ICentroThemeOptions>): void {
		this.centroThemeOptions = {...this.centroThemeOptions, ...updatedstate}; // Note that this is a shallow copy

		// we need to inform the existing listeners
		this.listeners.forEach((listener: ConfigUpdatedListener<ICentroThemeOptions>) => listener(this.centroThemeOptions));
	}
}
